let typed = new Typed('.auto-type', {
    strings: [
        'web developement',
        'react',
        'UI/UX'
    ],
    typeSpeed: 50,
    backSpeed: 50,
    loop: true
});

//# sourceMappingURL=index.fed221bf.js.map
